import React from 'react'
import useCrashStore from '../store/useCrashStore'
import CrashWinSkin, { CrashPendingWinSkin } from './CrashWinSkin'

/**
 * Плашки после вывода своей ставки: «подбираем предмет» + карточка
 * выигранного скина. Показываются на mobile и desktop.
 *
 * Состав, сумма и статус ставки отдельной карточкой больше не рисуются:
 * они видны в своей строке списка игроков и в единой кнопке действия
 * (CrashActionButton «Ваша ставка ·N» / «Выведено +N» / «Проиграно −N»).
 */
export const CrashMyBetWinSkin = () => {
  const players = useCrashStore((s) => s.players)
  const myChatId = useCrashStore((s) => s.myChatId)
  const winSkin = myChatId ? players.get(String(myChatId))?.winSkin : null

  return (
    <div className="space-y-2">
      <CrashPendingWinSkin />
      {winSkin && <CrashWinSkin skin={winSkin} />}
    </div>
  )
}
